{
    "MainTitleAdd": "Fügen Sie die zentrale Verwaltungsumgebung hinzu",
    "MainTitleModify": "Ändern Sie die zentrale Verwaltungsumgebung",
    "DomainsTitle": "Domänenprofil",
    "ProvisioningTitle": "Bereitstellung",
    "EstateTitle": "Anwesen",
    "UnknownDescription": "[Unbekannte Beschreibung]",
    "LanguageCME_ButtonHelpLabel": "Hilfe?",
    "LanguageCME_ButtonSubmitLabel": "OK",
    "LanguageCME_ButtonCancelLabel": "Absagen",
    "LanguageCME_PromptMessage": "Möchten Sie dieses Fenster wirklich schließen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
    "LanguageCME_PromptConfirm": "Ja",
    "LanguageCME_PromptCancel": "Absagen",
    "LanguageCME_DetailsTitle": "CME-Details",
    "NAME": "LanguageCME",
    "LicenseManagementTitle": "Lizenzmanagement",
    "CME_AdvancedTabTitle": "Fortgeschrittene",
    "CME_Fields_RecursiveRealTimeBots": "Aktivieren\/Deaktivieren von Echtzeit für alle Tel-Server",
    "CME_EnableVoiceAppBots": "Start von Echtzeit-Warteschlangen für {} Tel-Server",
    "CME_EnableVoiceAppBots_Recursive": "Echtzeit-Warteschlangen für alle Tel-Server starten",
    "CME_DisableVoiceAppBots": "Stoppen von Echtzeit-Warteschlangen für {} Tel-Server",
    "CME_DisableVoiceAppBots_Recursive": "Echtzeit-Warteschlangen für alle Tel-Server anhalten",
    "CME_EnableVoiceAppBots_Confirmation_Title": "Bitte beachten Sie, dass die Aktivierung dieser Option zu einer Verschlechterung der Funktionalität innerhalb des Mieters führen kann. Diese Option sollte nur nach Rücksprache mit unserem Support-Team genutzt werden.",
    "CapabilitiesTitle": "Fähigkeiten",
    "BrandingTitle": "Markenbildung"
}